import React, { useEffect, useState } from 'react';
import {
  getAssessmentById,
  AssessmentDetail,
} from '@/services/PagesServices/AssessmentManagementService';
import AssessmentPreviewModal from './AssessmentPreviewModal';

interface AssessmentViewByIdProps {
  id: number;
  onClose: () => void;
}

const loadingOverlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15, 23, 42, 0.55)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  color: '#fff',
  fontSize: 14,
};

const card: React.CSSProperties = {
  background: '#fff',
  color: '#0f172a',
  padding: '16px 20px',
  borderRadius: 8,
  boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
  minWidth: 280,
  textAlign: 'center',
};

const closeBtn: React.CSSProperties = {
  marginTop: 12,
  background: '#1f2937',
  color: '#fff',
  border: 'none',
  padding: '6px 14px',
  borderRadius: 6,
  cursor: 'pointer',
  fontSize: 13,
};

const AssessmentViewById: React.FC<AssessmentViewByIdProps> = ({ id, onClose }) => {
  const [data, setData] = useState<AssessmentDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setData(null);
    setError(null);
    getAssessmentById(id).then((res) => {
      if (cancelled) return;
      if (res.success && res.data) setData(res.data);
      else setError(res.error?.message || 'Failed to load assessment.');
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (error) {
    return (
      <div style={loadingOverlay} onClick={onClose} role="dialog" aria-modal="true">
        <div style={card} onClick={(e) => e.stopPropagation()}>
          <div style={{ color: '#b91c1c', fontWeight: 600 }}>Couldn't load assessment</div>
          <div style={{ marginTop: 6, fontSize: 13, color: '#475569' }}>{error}</div>
          <button type="button" style={closeBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div style={loadingOverlay}>
        <div style={card}>Loading assessment…</div>
      </div>
    );
  }

  const totalPoints = data.questions.reduce((sum, q) => sum + (q.points || 0), 0);

  return (
    <AssessmentPreviewModal
      title={data.title}
      description={data.description}
      assessmentType={data.status}
      timeLimit={data.timeLimit != null ? String(data.timeLimit) : ''}
      passingScore={data.passingScore != null ? String(data.passingScore) : null}
      attemptsAllowed={data.attemptsAllowed != null ? String(data.attemptsAllowed) : null}
      randomizeQuestions={data.randomizeQuestions}
      immediateFeedback={data.immediateFeedback}
      questions={data.questions}
      totalPoints={totalPoints}
      onClose={onClose}
    />
  );
};

export default AssessmentViewById;
